<template>
  <teleport to="body">
    <transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div
        v-if="modelValue"
        class="fixed inset-0 z-40">
        <!-- Backdrop -->
        <div
          v-if="backdrop"
          class="absolute inset-0 bg-black/30"
          @click="close()" />
      </div>
    </transition>

    <!-- Panel -->
    <transition
      enter-active-class="transition-transform duration-300 ease-out"
      :enter-from-class="placement === 'end' ? 'translate-x-full' : '-translate-x-full'"
      enter-to-class="translate-x-0"
      leave-active-class="transition-transform duration-200 ease-in"
      leave-from-class="translate-x-0"
      :leave-to-class="placement === 'end' ? 'translate-x-full' : '-translate-x-full'">
      <div
        v-if="modelValue"
        :class="['fixed top-0 z-50 h-full bg-surface shadow-flyout flex flex-col', placement === 'end' ? 'right-0' : 'left-0']"
        :style="{ width: width }">
        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-4 border-b border-line flex-shrink-0">
          <slot name="header">
            <h2
              v-if="title"
              class="text-base font-semibold text-ink">
              {{ title }}
            </h2>
          </slot>
          <button
            class="p-1.5 rounded-lg text-muted hover:text-ink hover:bg-surfaceAlt transition-colors"
            @click="close">
            <X class="w-4 h-4" />
          </button>
        </div>

        <!-- Body -->
        <div :class="['flex-1 overflow-y-auto', bodyPadding]">
          <slot />
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { X } from '@lucide/vue'

export default {
  name: 'AppOffcanvas',
  components: { X },
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: '' },
    placement: { type: String, default: 'end' },
    width: { type: String, default: '420px' },
    backdrop: { type: Boolean, default: true },
    bodyPadding: { type: String, default: 'p-5' },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown)
    document.body.style.overflow = ''
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false)
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.modelValue) this.close()
    },
  },
}
</script>
